import { render, staticRenderFns } from "./trendingProducts.vue?vue&type=template&id=8a8db5a4&scoped=true"
import script from "./trendingProducts.vue?vue&type=script&lang=ts"
export * from "./trendingProducts.vue?vue&type=script&lang=ts"
import style0 from "./trendingProducts.vue?vue&type=style&index=0&id=8a8db5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8db5a4",
  null
  
)

export default component.exports